<template>
  <cy-drawer title="添加/编辑" v-model="visible" :loading="loading" @cancel="cancel" @confirm="submit('form')">
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-alert :message="$t('基本信息')" type="success" />
      <a-row :gutter="10">
        <a-col
          :lg="4"
        ><a-form-model-item
          :label="$t('图片')"
          prop="mainImg"
        >
          <file-upload ref="upload" @change="uploadChange('mainImg', $event)"></file-upload>
        </a-form-model-item
        ></a-col>
        <a-col
          :lg="20"
        ><a-form-model-item
          :label="$t('菜谱标题')"
          prop="title"
        ><a-input v-model="form.title" :placeholder="$t('请输入')" :maxLength="255"></a-input></a-form-model-item
        ></a-col>
        <a-col
          :lg="6"
        ><a-form-model-item
          :label="$t('菜谱所属分类')"
          prop="classifyId"
        >
          <a-select v-model="form.classifyId" :placeholder="$t('请选择')">
            <a-select-option v-for="item in fenleiList" :key="item.id" :value="item.id">{{ item.classifyName }}</a-select-option>
          </a-select>
        </a-form-model-item
        ></a-col>
        <!-- <a-col
          :lg="24"
        ><a-form-model-item
          :label="$t('菜谱描述')"
          prop="content"
        ><a-textarea v-model="form.content" maxlength="250" :placeholder="$t('请输入')"></a-textarea></a-form-model-item
        ></a-col> -->

      </a-row>
      <a-alert :message="$t('配料信息')" type="info" />
      <a-row :gutter="10">

        <a-col
          :lg="24"
        >
          <div class="flex align-center" v-for="(item,index) in form.condiment" :key="`peiliao-${index}`">
            <a-form-model-item
              style="width: 100%"
              :label="index==0?$t('配料名称'):''"
              :prop="`condiment.${index}.name`"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.name" :placeholder="$t('请输入')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              :label="index==0?$t('用量'):''"
              :prop="`condiment.${index}.content`"
              style="margin-left: 10px;width: 100%;"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.content" :placeholder="$t('例：1个')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              prop="remark"
              style="margin-left: 10px;"
              v-if="form.condiment.length>1"
            ><a-button :style="{marginTop: index==0?'40px':''}" type="primary" shape="circle" icon="minus" @click="handleDel('condiment', index)" /></a-form-model-item
            >
          </div>
          <a-form-model-item style="width: 100%;">
            <a-button type="dashed" style="width: 100%;" @click="handleAdd('condiment', { name: '', content: '' })">{{ $t('添加') }}</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-alert :message="$t('做法步骤')" type="info" />
      <a-row :gutter="10" v-for="(item,index) in form.stepDevList" :key="`zuofa-${index}`">
        <a-col
          :lg="4"
        ><a-form-model-item
          :label="index==0?$t('序号'):''"
          :prop="`stepDevList.${index}.sort`"
          :rules="{required: true, message: $t('请输入序号')}"
        >
          <a-input v-model="item.sort" :placeholder="$t('请输入')"></a-input>
        </a-form-model-item
        >
        </a-col>
        <a-col
          :lg="20"
        ><a-form-model-item
          :label="index==0?$t('内容'):''"
          :prop="`stepDevList.${index}.content`"
          :rules="{required: true, message: $t('请输入')}"
        >
          <div class="flex align-center">
            <a-textarea rows="1" v-model="item.content" :placeholder="$t('请输入')" :maxLength="255"></a-textarea>
            <a-button
              v-if="form.stepDevList.length>1"
              class="flex-shrink"
              style="margin-left: 10px;"
              type="primary"
              shape="circle"
              icon="minus"
              @click="handleDel('stepDevList', index)"
            ></a-button>
          </div>
        </a-form-model-item
        >
        </a-col>
      </a-row>
      <a-button
        type="dashed"
        style="width: 100%;"
        @click="handleAdd('stepDevList', {
          'content': '',
          'remark': '',
          'sort': form.stepDevList.length+1
        })">{{ $t('添加') }}</a-button>
    </a-form-model>
  </cy-drawer>
</template>
<script>
import CyDrawer from '@/components/CyDarwer'
import { mapGetters } from 'vuex'
import { addObj, putObj, getObj } from '../api'
import { fetchList } from '@/views/program/device-repice/type/api'
export default {
  // 组件名称
  name: 'CreateForm',
  // 过滤器
  filters: {},
  // 组件
  components: {
    CyDrawer,
    FileUpload: () => import('@/components/FileUpload/index2')
  },
  // props类型
  props: {
    model: {
      type: Object,
      default: () => null
    }
  },
  // 数据

  data() {
    return {
      visible: false,
      loading: false,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      URL: process.env.VUE_APP_API_BASE_URL + '/api/common/upload',
      baseurl: process.env.VUE_APP_API_BASE_URL,
      imgList: [],
      form: {
        'classifyId': undefined,
        'condiment': [
          { name: '', content: '' }
        ],
        'content': '',
        'id': 0,
        'mainImg': '',
        'remark': '',
        'stepDevList': [
          {
            'content': '',
            'remark': '',
            'sort': 1
          }
        ],
        'title': ''
      },
      rules: {
        classifyId: [{ required: true, message: this.$t('请选择') }],
        title: [{ required: true, message: this.$t('请输入') }],
        mainImg: [{ required: true, message: this.$t('请上传封面图') }],
        content: [{ required: true, message: this.$t('请输入菜谱描述') }]
      },
      editFlag: true,
      select: {
        provinceId: null,
        cityId: null,
        areaId: null
      },
      fenleiList: []
    }
  },
  // 计算属性
  computed: {
    ...mapGetters(['roleList'])
  },
  // 计算属性监听
  watch: {},
  // 创建时
  created() {
    this.getFenleiList()
  },
  // 挂载完毕
  mounted() {},
  // 方法
  methods: {
    getFenleiList() {
      fetchList({ pageNum: 1, pageSize: 2 ** 31 - 1 }).then(res => {
        console.log(res)
        this.fenleiList = res.data.records
      })
    },
    handleDel(key, index) {
      this.form[key].splice(index, 1)
    },
    handleAdd(key, obj) {
      this.form[key].push(JSON.parse(JSON.stringify(obj)))
    },
    uploadChange(key, e) {
      this.form[key] = e ? e.url : undefined
    },
    handleSetpUpload(index, e) {
      this.form.stepDevList[index].img = e ? e.url : undefined
    },
    editorChange(e) {
      console.log(e)
      if (e === '<p><br></p>') {
        this.form.content = ''
      } else {
        this.form.content = e
      }
    },
    handleUploadChange(values) {
      console.log(values)
      this.form.iamTypeNum = values.length > 1 ? 2 : 1
      this.form.iamgePaths = values.map((item) => item.shortcutUrl).join(',')
    },
    del(index) {
      this.form.propDrops.splice(index, 1)
    },
    addDomain() {
      const obj = {
        propNum: undefined,
        num: 0,
        infeRate: 0
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.propDrops.push(JSON.parse(JSON.stringify(obj)))
        }
      })
    },
    init(id) {
      if (id) this.form.id = id
      this.visible = true
      this.$nextTick(() => {
        console.log(this.$refs)

        if (id) {
          this.loading = true
          getObj(this.form.id).then((res) => {
            const keyArr = ['condiment']
            this.form = res.data
            this.$refs.upload.init(this.form.mainImg ? {
              fileExplainName: this.form.mainImg,
              filePath: this.form.mainImg,
              fileId: this.form.id
            } : '', 200, 200)
            for (const key in this.form) {
              if (keyArr.includes(key)) {
                this.form[key] = JSON.parse(this.form[key])
              }
            }

            console.log(this.form)
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.$refs.upload.init('', 200, 200)
        }
      })
    },
    cancel() {
      this.visible = false
      this.$emit('close')
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          const form = JSON.parse(JSON.stringify(this.form))
          const keyArr = ['condiment', 'excipients', 'ingredients']
          for (const key in form) {
            if (keyArr.includes(key)) {
              form[key] = JSON.stringify(form[key])
            }
          }
          console.log(this.form)
          if (this.form.id) {
            putObj(form)
              .then((res) => {
                this.cancel()
                this.$emit('refresh')
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            addObj(form)
              .then((res) => {
                this.cancel()
                this.$emit('refresh')
              })
              .catch(() => {
                this.loading = false
              })
          }
        }
      })
    },
    handlecoverPicList(e) {
      console.log(e)
      if (e.length > 0) {
        this.form.avatar = e[0].url
      }
    },
    change() {},
    selected(e) {
      console.log(e)
      this.form.province = e.province.value
      this.form.city = e.city.value
      this.form.area = e.area.value
    }
  }
}
</script>

<style lang="less" scoped>
.amap-demo {
  height: 300px;
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.daoju {
  position: relative;
  .del {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
